import loader from "../../assets/loader.gif";

function BALoader(props) {
  const { size } = props
  return (
    <>
      <div className="d-flex justify-content-center align-items-center">
        <img className="rounded-pill" src={loader} width={size ?? "220px"} />
      </div>
    </>
  );
}
export default BALoader;
